import script from "./NewsPageBodyPostHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageBodyPostHeader.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageBodyPostHeader.vue?vue&type=style&index=0&id=01aa8690&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01aa8690"]])

export default __exports__